import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../helper/local-storage.keys';
import { Competition } from '../model/competition/Competition';
import { NotificationHandler } from '../helper/notification.handler';
import { LocalStorageService } from 'ngx-webstorage';
import { CompetitionService } from './competition.service';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  constructor(private competitionService: CompetitionService,
              private authService: AuthService,
              private localStorageService: LocalStorageService) {
  }

  public loadTenantDetails(): void {
    let tenant = TenantService.getSubdomain();
    if (tenant == 'app') tenant = '';

    if (!tenant) {
      this.localStorageService.clear(LocalStorageKeys.SESSION_TENANT);
      this.localStorageService.store(LocalStorageKeys.SESSION_TENANT_CHECKED, true);
    } else {
      const competition = this.localStorageService.retrieve(LocalStorageKeys.SESSION_TENANT) as Competition;
      if (!competition || tenant != competition.domain) {
        this.localStorageService.clear(LocalStorageKeys.SESSION_TENANT);
        this.localStorageService.clear(LocalStorageKeys.SESSION_TENANT_CHECKED);

        this.competitionService.getDomainDetails(tenant).subscribe({
          next: competition => {
            this.localStorageService.store(LocalStorageKeys.SESSION_TENANT, competition);
            this.localStorageService.store(LocalStorageKeys.SESSION_TENANT_CHECKED, true);

            this.authService.updateTenantConfig(competition.name, competition.domain);
          }, error: error => {
            NotificationHandler.handleError($localize`:Notifications|Competition details fetch has failed message@@notifications-competition-details-fetch-failed-error:Competition details fetch has failed`, error);
          }, complete: () => {
            this.localStorageService.store(LocalStorageKeys.SESSION_TENANT_CHECKED, true);
          }
        });
      }
    }
  }

  public getTenant(): Competition | null {
    return this.localStorageService.retrieve(LocalStorageKeys.SESSION_TENANT) as Competition;
  }

  public getTenantChecked(): boolean {
    return this.localStorageService.retrieve(LocalStorageKeys.SESSION_TENANT_CHECKED) == true;
  }

  public getTenantUpdates(): Observable<Competition> {
    return this.localStorageService.observe(LocalStorageKeys.SESSION_TENANT) as Observable<Competition>;
  }

  public getTenantCheckedUpdates(): Observable<boolean> {
    return this.localStorageService.observe(LocalStorageKeys.SESSION_TENANT_CHECKED) as Observable<boolean>;
  }

  public unsubscribe(tenantSubscription?: Subscription): void {
    if (tenantSubscription) {
      tenantSubscription.unsubscribe();
    }
  }

  public static getSubdomain(): string {
    const domain = window.location.hostname;
    const parts = domain.split('.');

    let subdomain = '';
    if (parts.length > 1 && parts[0] != 'dev' && parts[0] != 'quizwin') {
      subdomain = parts[0];
    }

    return subdomain;
  }

}
